import { RouteInterface } from "src/common";
import config from "src/config";
import { NotFoundPage } from "src/pages/global/notFound/notFound.page";
import BasicDataPage from "../basicData.page";
import PayPage from "../checkout.page";
import CheckoutFailurePageWithHook from "../checkoutFailure.page";
import CheckoutSuccessPage from "../checkoutSuccess.page";
import OffersPage from "../offers.page";
import PassengerDataPage from "../passengerData.page";
import RootPage from "../root.page";
import SelectedOfferPage from "../selectedOffer.page";
import { AppRoutes } from "./app.routes";
import TermsAndConditionsPage from "../termsAndConditions.page";
import CheckoutSuccessOfflinePage from "../checkoutSuccessOffline.page";

export const AppRouting: Array<RouteInterface> = [
  {
    path: AppRoutes.ROOT,
    element: () => config.REACT_APP_IS_DEV === 'true' ? RootPage() : NotFoundPage(),
    functions: []
  },
  {
    path: AppRoutes.WEBSHOP.STEP_1,
    element: () => <BasicDataPage />,
    functions: [],
    pageName: 'Osnovno'
  },
  {
    path: `${AppRoutes.WEBSHOP.STEP_1}/so/:soId`,
    element: () => <BasicDataPage />,
    functions: [],
    pageName: 'Osnovno - povratni link'
  },
  {
    path: AppRoutes.WEBSHOP.STEP_2,
    element: () => <PassengerDataPage />,
    functions: [],
    pageName: 'Putnici'
  },
  {
    path: `${AppRoutes.WEBSHOP.STEP_2}/so/:soId`,
    element: () => <PassengerDataPage />,
    functions: [],
    pageName: 'Putnici - povratni link'
  },
  {
    path: AppRoutes.WEBSHOP.STEP_3,
    element: () => <OffersPage />,
    functions: [],
    pageName: 'Ponude'
  },
  {
    path: `${AppRoutes.WEBSHOP.STEP_3}/so/:soId`,
    element: () => <OffersPage />,
    functions: [],
    pageName: 'Ponude - povratni link'
  },
  {
    path: `${AppRoutes.WEBSHOP.STEP_4}`,
    element: () => <SelectedOfferPage />,
    functions: [],
    pageName: 'Ponuda'
  },
  {
    path: `${AppRoutes.WEBSHOP.STEP_4}/so/:soId/offer/:offerId`,
    element: () => <SelectedOfferPage />,
    functions: [],
    pageName: 'Ponuda - povratni link'
  },
  {
    path: AppRoutes.WEBSHOP.CHECKOUT,
    element: () => <PayPage />,
    functions: [],
    pageName: 'Plaćanje'
  },
  {
    path: `${AppRoutes.WEBSHOP.CHECKOUT}/so/:soId/offer/:offerId`,
    element: () => <PayPage />,
    functions: [],
    pageName: 'Plaćanje - povratni link'
  },
  {
    path: AppRoutes.WEBSHOP.CHECKOUT_SUCCESS,
    element: () => <CheckoutSuccessPage />,
    functions: [],
    pageName: 'Plaćanje - uspjeh'
  },
  {
    path: AppRoutes.WEBSHOP.CHECKOUT_FAILURE,
    element: () => <CheckoutFailurePageWithHook />,
    functions: [],
    pageName: 'Plaćanje - neuspjeh'
  },
  {
    path: `${AppRoutes.TERMS_AND_CONDITIONS}/:offerId`,
    element: () => <TermsAndConditionsPage />,
    functions: [],
    pageName: 'Uvjeti osiguranja'
  },
  {
    path: AppRoutes.WEBSHOP.CHECKOUT_SUCCESS_OFFLINE,
    element: () => <CheckoutSuccessOfflinePage />,
    functions: [],
    pageName: 'Plaćanje - uspjeh - offline'
  }
];
